module.exports = __webpack_public_path__ + "media/images/png/home-83dbf2fd022944f70308d2d59d7fa5b6.png";